import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import ValidationForm from "../../../../../components/ValidationForm";

class DaliEsSystemSceneForm extends Component {

    state = {
        form: {
            id: null,
            label: null,
            sceneNumber: null,
            isActive: false,
            isDefault: false,
            daliEsSystemGroupId: null
        },
        isEdit: false
    };

    componentDidMount() {
        if(!this.props.data) {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    daliEsSystemGroupId: parseInt(this.props.groupId),
                    isDefault: false,
                    isEnabled: false,
                    isActive: false
                },
                isEdit: false
            });
        }

        if(this.props.data) {
            const { data } = this.props;
            this.setState({
                ...this.state,
                isEdit: true,
                form: {
                    id: data.id,
                    label: data.label,
                    sceneNumber: data.sceneNumber,
                    isEnabled: data.isEnabled,
                    isActive: data.isActive,
                    isDefault: data.isDefault,
                    daliEsSystemGroupId: data.daliEsSystemGroupId
                }
            })
        }
    }

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    };

    handleOnChangeCheckbox = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.checked
            }
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.submitForm(this.state.form);
    };

    render() {
        const { t, validationForm } = this.props;
        const { form } = this.state;

        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <label className="col-form-label">{t('scene-number')}</label>
                        <input
                            className={`form-control ${validationForm?.errorMessages['SceneNumber'] ? "is-invalid" : ''}`}
                            type="number"
                            name="sceneNumber"
                            title="sceneNumber"
                            value={!isNaN(form.sceneNumber) ? form.sceneNumber :  ""}
                            onChange={this.handleOnChangeInput}
                            required
                        />
                        <ValidationForm validationKey={validationForm?.errorMessages['SceneNumber']}/>

                    </div>

                    <div className="form-group">
                        <label className="col-form-label">{t('label')}</label>
                        <input
                            className="form-control"
                            name="label"
                            title="label"
                            value={form.label || ''}
                            onChange={this.handleOnChangeInput}
                        />
                    </div>

                    <div className="form-group">
                        <input
                            type="checkbox"
                            name="isEnabled"
                            checked={form?.isEnabled || false}
                            value={form?.isEnabled || false}
                            onChange={this.handleOnChangeCheckbox} />
                        &nbsp;
                        <label className="col-form-label">{t('is-enabled')}</label>
                    </div>

                    <div className="form-group">
                        <input
                            type="checkbox"
                            name="isDefault"
                            checked={form?.isDefault || false}
                            value={form?.isDefault || false}
                            onChange={this.handleOnChangeCheckbox} />
                            &nbsp;
                        <label className="col-form-label">{t('is-default')}</label>
                    </div>

                    <div className="form-group float-right">
                        { this.state.isEdit ? (
                            <button type="submit" className={"btn btn-primary" }>
                                <i className="fas fa-edit"> </i> {t('edit')}
                            </button>
                        ) : (
                            <button type="submit" className={"btn btn-success" }>
                                <i className="fas fa-plus"> </i> {t('create')}
                            </button>
                        ) }
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { validationForm } = state.daliEsSystemReducer;
    return {
        validationForm
    }
};
export default withNamespaces()(connect(mapStateToProps)(DaliEsSystemSceneForm));
